import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ADDRESS_DATA = {
  types: ['mail', 'delivery', 'invoice'],
  street: '',
  apartmentNumber: '',
  addressLine2: '',
  zipcode: '',
  city: '',
  country: '',
  countryName: '',
};

Address.propTypes = {
  data: PropTypes.shape({
    types: PropTypes.arrayOf(PropTypes.string),
    street: PropTypes.string,
    apartmentNumber: PropTypes.string,
    addressLine2: PropTypes.string,
    zipcode: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    countryName: PropTypes.string,
  }),
};

function Address({ data = DEFAULT_ADDRESS_DATA, className, ...props }) {
  const {
    // types,
    street,
    apartmentNumber: apartmentNumberTemp1,
    apartment_number: apartmentNumberTemp2,
    addressLine2: addressLine2Temp1,
    address_line2: addressLine2Temp2,
    zipcode,
    city,
    country,
    countryName,
  } = data;

  const apartmentNumber = apartmentNumberTemp1 || apartmentNumberTemp2;
  const addressLine2 = addressLine2Temp1 ?? addressLine2Temp2;

  return (
    <div className={`address${className ? ' ' + className : ''}`} {...props}>
      <div className="street">
        {street}
        {apartmentNumber ? ` (${apartmentNumber})` : ''}
        {addressLine2 ? (
          <>
            <br />
            {addressLine2}
          </>
        ) : null}
      </div>
      <div className="city">
        {zipcode} {city}
      </div>
      {countryName && (
        <div className="country">
          {countryName} ({country})
        </div>
      )}
    </div>
  );
}

export default Address;
